module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_9005.91568fde.png";